document.addEventListener('click', function (e) {
    const button = e.target.closest('.faq-accordion');
    if (button) {
        let target = button;
        const selected_accordion = target.closest('.accordion-wrapper');
        const accordion_parent = target.closest('.accordion-faqs-groups');
        const sibling_accordions = accordion_parent.querySelectorAll('.accordion-wrapper');

        console.log('Accordion parent', accordion_parent);

        // IF already active - Close
        if ( selected_accordion.classList.contains('active') ) {
            selected_accordion.classList.remove('active');
        } else {

            // Close sibling accordions
            sibling_accordions.forEach( accordion => {
                accordion.classList.remove('active');
            });

            // Activate Selected Accordion
            selected_accordion.classList.add('active');
        }
    }
});